import { render } from "./PaymentTypesPanel.vue?vue&type=template&id=c1d0a366&scoped=true&ts=true"
import script from "./PaymentTypesPanel.vue?vue&type=script&lang=ts"
export * from "./PaymentTypesPanel.vue?vue&type=script&lang=ts"

import "./PaymentTypesPanel.vue?vue&type=style&index=0&id=c1d0a366&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c1d0a366"]])

export default __exports__